import React from 'react';

const UnderConstruction = () => {
  const primaryColor = "#1a67a3";
  const secondaryColor = "#e5b44c";

  return (
    <div className="container-fluid" style={{ backgroundColor: '#fdfdfd', minHeight: '100vh' }}>
      <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="col-12 col-md-8 col-lg-6 text-center">
          
          {/* Icono Central con Animación */}
          <div className="d-flex justify-content-center mb-4">
            <div 
              style={{ 
                width: '100px', 
                height: '100px', 
                borderRadius: '50%', 
                border: `3px dashed ${secondaryColor}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: 'spin 10s linear infinite'
              }}
            >
              <div 
                style={{ 
                  backgroundColor: primaryColor, 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                }}
              >
                <i className="fa fa-wrench text-white" style={{ fontSize: '1.8rem' }}></i>
              </div>
            </div>
          </div>

          {/* Textos en Inglés */}
          <h1 className="display-4 font-weight-bold mb-3" style={{ color: primaryColor }}>
            Under Construction
          </h1>
          
          <h3 className="h5 mb-4" style={{ color: secondaryColor, letterSpacing: '2px', textTransform: 'uppercase' }}>
            We are crafting something special
          </h3>

          <p className="text-muted mb-5 px-lg-5" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
            Our team is currently working on the final details of our new website. 
            We'll be back online with a brand new experience very soon.
          </p>

          {/* Barra de Progreso Bootstrap 4 */}
          <div className="progress mb-5" style={{ height: '10px', borderRadius: '20px', backgroundColor: '#e9ecef' }}>
            <div 
              className="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar" 
              style={{ 
                width: '75%', 
                backgroundColor: primaryColor,
                borderRadius: '20px'
              }} 
              aria-valuenow="75" 
              aria-valuemin="0" 
              aria-valuemax="100"
            ></div>
          </div>

          {/* Footer / Contact */}
          <div className="pt-4 border-top">
            <p className="small text-secondary mb-0">
              Need to get in touch? <br />
              <a href="mailto:info@propagile.com" className="font-weight-bold" style={{ color: primaryColor }}>
                Email our support team
              </a>
            </p>
          </div>

        </div>
      </div>

      {/* Keyframes para la rotación del borde */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default UnderConstruction;